export enum CardRequestStatusesEnum {
    PENDING = 'PENDING',
    REJECTED = 'REJECTED',
    COMPLETED = 'COMPLETED',
    READY_FOR_PICKUP = 'READY_FOR_PICKUP',
}

export enum CardRequestType {
    CLASSIC = 'CLASSIC',
    GOLD = 'GOLD',
    PLATINUM = 'PLATINUM',
}

export const CardRequestCardProductType: Record<CardRequestType, string> = {
    [CardRequestType.CLASSIC]: 'VISA-CLASSIC-USD-CP-PHYSICAL',
    [CardRequestType.GOLD]: 'VISA-GOLD-USD-CP-PHYSICAL',
    [CardRequestType.PLATINUM]: 'VISA-PLATINUM-USD-CP-PHYSICAL',
};
